import { css } from 'linaria';

export const stepStyles = css`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
`;
export const stepNumberStyles = css`
	display: flex !important;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	color: var(--text-primary-invert);
	background-color: #464c5c;
	border-radius: 50%;
`;
export const stepTitleStyles = css`
	margin: 16px 0px 8px 0px !important;
`;
